import { render, staticRenderFns } from "./WhatsappTemplates.vue?vue&type=template&id=103db4b9&scoped=true"
import script from "./WhatsappTemplates.vue?vue&type=script&lang=js"
export * from "./WhatsappTemplates.vue?vue&type=script&lang=js"
import style0 from "./WhatsappTemplates.vue?vue&type=style&index=0&id=103db4b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103db4b9",
  null
  
)

export default component.exports